module.exports = __webpack_public_path__ + "static/media/wedding10.194948e6.jpg";